import { isEqual } from 'lodash'

export const validateIpAddress = (value: string) => {
  //
  // empty value evaluates to true to allow empty field
  // to pass validation. Use 'required' validation
  // in addition to this one to validate for presence
  // of value.
  //
  if (isEqual(value, '')) {
    return true || ''
  }
  const regex =
    /^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/
  return regex.test(value) || ipAddressHint
}

export const ipAddressHint = 'Valid IPv4 address (xxx.xxx.xxx.xxx)'
